import React from 'react';

// Google map pointing to Seedly's location.
const GoogleMap = () => {
  return (
    <iframe
      title="googleMap"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.832227380321!2d103.8440409658992!3d1.2738812490708782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19dd34b9c777%3A0x5ccf6c58bc65f203!2sEon%20Shenton!5e0!3m2!1sen!2ssg!4v1672904419772!5m2!1sen!2ssg"
      width="100%"
      height="100%"
      frameBorder="0"
      style={{ border: 0 }}
      allow="fullscreen"
    />
  );
};

export default GoogleMap;
